import React, { useState } from "react";
import {
	Box,
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	Typography
} from "@mui/material";
import ButtonComponent from "../../ButtonComponent";
const UrlNavigatorPwa = ({
	open,
	onClose,
	handleNavigation,
	isLoading
}: {
	open: boolean;
	onClose: () => void;
	handleNavigation: (url: string) => void;
	isLoading: boolean;
}) => {
	const [urlState, setUrlState] = useState("");

	const handleURLNavigation = () => {
		handleNavigation(urlState);
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth={"xs"}
		>
			<DialogTitle id="alert-dialog-title">Navigate</DialogTitle>
			<DialogContent>
				{<Typography style={{ fontSize: "14px" }}>Paste notification url and hit Navigate</Typography>}
				<Box my={1} width={"100%"}>
					<TextField
						label={"Navigation URL"}
						fullWidth={true}
						value={urlState}
						onChange={e => setUrlState(e.target.value)}
						sx={{
							"& .MuiOutlinedInput-root": {
								background: "#fff"
							}
						}}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<ButtonComponent
					onClick={handleURLNavigation}
					disabled={urlState.trim().length === 0 || isLoading}
					loading={isLoading}
					text={"Navigate"}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default UrlNavigatorPwa;
